(function () {
  'use strict';

  /* Mobilmenu */
  var toggle = document.querySelector('.header__toggle');
  var nav = document.getElementById('primary-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Opdater antal i kurv-ikonet */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('[data-cart-count]');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  /* Produktbilleder */
  var mainImage = document.querySelector('[data-main-image]');
  var thumbs = document.querySelectorAll('[data-thumb]');

  function showMedia(src, mediaId) {
    if (!mainImage || !src) return;
    mainImage.src = src;
    mainImage.removeAttribute('srcset');
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', mediaId ? t.getAttribute('data-media-id') === String(mediaId) : false);
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showMedia(thumb.getAttribute('data-full'), thumb.getAttribute('data-media-id'));
    });
  });

  /* Antalsvælger */
  var qty = document.querySelector('[data-qty]');
  if (qty) {
    var qtyInput = qty.querySelector('[data-qty-input]');
    qty.querySelector('[data-qty-minus]').addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
    qty.querySelector('[data-qty-plus]').addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }


  /* Forstør billede */
  var zoom = document.querySelector('[data-zoom]');
  if (zoom) {
    var zoomImg = zoom.querySelector('[data-zoom-image]');
    function openZoom() {
      if (!mainImage) return;
      zoomImg.src = mainImage.src;
      zoomImg.alt = mainImage.alt;
      zoom.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeZoom() {
      zoom.hidden = true;
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-open-zoom], [data-zoomable]').forEach(function (el) {
      el.addEventListener('click', openZoom);
    });
    zoom.querySelector('[data-close-zoom]').addEventListener('click', closeZoom);
    zoom.addEventListener('click', function (e) { if (e.target === zoom) closeZoom(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !zoom.hidden) closeZoom(); });
  }

  /* Tegntæller i kontaktformular */
  var body = document.getElementById('ContactBody');
  var counter = document.querySelector('[data-char-count]');
  if (body && counter) {
    var updateCount = function () { counter.textContent = body.value.length; };
    body.addEventListener('input', updateCount);
    updateCount();
  }

  /* Produktformular */
  var form = document.querySelector('.product__form');
  if (!form) return;

  var master = form.querySelector('[data-variant-select]');
  var optionInputs = form.querySelectorAll('[data-option-value]');
  var priceEl = document.querySelector('[data-price]');
  var compareEl = document.querySelector('[data-compare]');
  var button = form.querySelector('[data-add-button]');
  var buttonText = form.querySelector('[data-add-text]');
  var feedback = form.querySelector('[data-add-feedback]');

  function selectedOptions() {
    var groups = {};
    optionInputs.forEach(function (input) {
      if (input.checked) groups[input.name] = input.value;
    });
    return Object.keys(groups).sort().map(function (k) { return groups[k]; });
  }

  function sync() {
    if (!master || optionInputs.length === 0) return;
    var key = selectedOptions().join(' / ');
    var match = null;

    Array.prototype.forEach.call(master.options, function (opt) {
      if (opt.getAttribute('data-options') === key) match = opt;
    });

    if (!match) {
      if (button) button.disabled = true;
      if (buttonText) buttonText.textContent = 'Ikke tilgængelig';
      return;
    }

    master.value = match.value;
    if (priceEl) priceEl.textContent = match.getAttribute('data-price');
    if (compareEl) {
      var cmp = match.getAttribute('data-compare');
      compareEl.textContent = cmp || '';
      compareEl.hidden = !cmp;
    }

    var media = match.getAttribute('data-media');
    if (media) showMedia(media, match.getAttribute('data-media-id'));

    optionInputs.forEach(function (input) {
      if (!input.checked) return;
      var idx = input.name.replace('option-', '');
      var label = form.querySelector('[data-option-current="' + idx + '"]');
      if (label) label.textContent = input.value;
    });

    var stockEl = form.querySelector('[data-stock]');
    if (stockEl) {
      var left = parseInt(match.getAttribute('data-inventory'), 10);
      if (!match.disabled && !isNaN(left) && left > 0 && left <= 10) {
        stockEl.hidden = false;
        stockEl.textContent = 'Kun ' + left + ' tilbage';
      } else {
        stockEl.hidden = true;
        stockEl.textContent = '';
      }
    }

    if (button) button.disabled = match.disabled;
    if (buttonText) buttonText.textContent = match.disabled ? 'Udsolgt' : 'Læg i kurv';

    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.value);
    window.history.replaceState({}, '', url.toString());
  }

  optionInputs.forEach(function (input) { input.addEventListener('change', sync); });
  sync();

  /* Læg i kurv uden at forlade siden */
  form.addEventListener('submit', function (event) {
    if (!window.fetch) return;
    event.preventDefault();

    var data = new FormData(form);
    Array.from(data.keys()).forEach(function (key) {
      if (key.indexOf('option-') === 0) data.delete(key);
    });
    if (button) button.disabled = true;
    if (buttonText) buttonText.textContent = 'Tilføjer...';

    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (button) button.disabled = false;
        if (buttonText) buttonText.textContent = 'Læg i kurv';

        if (!res.ok) {
          if (feedback) {
            feedback.hidden = false;
            feedback.className = 'product__feedback product__feedback--error';
            feedback.textContent = res.body.description || 'Produktet kunne ikke lægges i kurven.';
          }
          return;
        }

        refreshCartCount();
        if (feedback) {
          feedback.hidden = false;
          feedback.className = 'product__feedback product__feedback--ok';
          feedback.innerHTML = 'Lagt i kurven. <a href="/cart">Gå til kurv</a>';
        }
      })
      .catch(function () { form.submit(); });
  });
})();
